export enum MoveRequestValueType {
	Hours = 1,
	Percentage = 2
}